import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useTheme } from '@mui/material/styles'
import * as Sentry from '@sentry/react'
import { TwoColumnLayout } from 'components/layouts'
import {
  ArtistApplyHeader,
  ArtistFormQuestions,
  FormInputs,
  useArtistApplyPageStyles,
} from 'components/pages/artist-apply'
import ArtistApplyForm from 'components/pages/artist-apply/Form'
import { ARTIST_FORM_QUESTIONS } from 'constants/artist'
import withLoader from 'hooks/loader'
import type { GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import { useState } from 'react'
import { Element, scroller } from 'react-scroll'

interface ArtistApplyPageProps {
  questions: ArtistFormQuestions
}

const ArtistApplyPage: NextPage<ArtistApplyPageProps> = ({ questions }) => {
  const styles = useArtistApplyPageStyles()
  const [step, setStep] = useState(1)
  const theme = useTheme()
  const isAboveMD = useMediaQuery(theme.breakpoints.up('md'))

  const onFormSubmit = async (data: FormInputs) => {
    try {
      // eslint-disable-next-line
      const res: any = await fetch(
        `https://apiadmin.inckd.com/api/profile/artist/verification/request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: data.name,
            last_name: '',
            email: data.email,
            country: data.country,
            city_name: data.location,
            instagram: data.instagram,
            source: 'web',
          }),
        }
      )

      const result = await res.json()
      if (!res.ok || !result || !result.detail) return false
      setStep(2)
      scroller.scrollTo('form', {})
      // @ts-ignore
      //gtag('event', 'request_invite_sent') // gtag event
      return true
    } catch (error) {
      Sentry.captureException(error)
      return false
    }
  }

  return (
    <Box>
      <Head>
        <title>Join as an Artist | inckd.</title>
        <meta name="description" content="Join us as an inckd. artist" />
        <link rel="canonical" href="https://inckd.com/apply" />
      </Head>

      <Element name="form">
        <Container component="main" maxWidth="xl" sx={styles.container}>
          <TwoColumnLayout
            gridItemOne={
              isAboveMD || step === 1 ? (
                <ArtistApplyHeader step={step} />
              ) : step === 1 ? (
                <ArtistApplyHeader step={step} />
              ) : (
                <ArtistApplyForm
                  step={step}
                  onSubmit={onFormSubmit}
                  questions={questions}
                />
              )
            }
            gridItemTwo={
              isAboveMD ? (
                <ArtistApplyForm
                  step={step}
                  onSubmit={onFormSubmit}
                  questions={questions}
                />
              ) : step === 1 ? (
                <ArtistApplyForm
                  step={step}
                  onSubmit={onFormSubmit}
                  questions={questions}
                />
              ) : (
                <ArtistApplyHeader step={step} />
              )
            }
          />
        </Container>
      </Element>
    </Box>
  )
}
export const getStaticProps: GetStaticProps<
  ArtistApplyPageProps
> = async () => {
  return {
    props: {
      messages: (await import(`locales/en/artist-apply.json`)).default,
      questions: ARTIST_FORM_QUESTIONS,
    },
  }
}

export default withLoader(ArtistApplyPage)
